import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top of new page automatically, every time the page changes.
// Taken from here:  https://stackoverflow.com/a/61602724
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
